import React from 'react';
import CalendarDesktopPage from '../../../components/shifts/shiftsDesktop/CalendarDesktopPage/CalendarDesktopPage';

const shiftsDesktopPage = () => {
    return (
        <CalendarDesktopPage />
    )
}

export default shiftsDesktopPage;
